(function ($) {
    "use strict";

    console.log('IUSAC FILTERS SCRIPT ZAŁADOWANY - Wersja z niezależnymi akordeonami');

    let isAccordionAnimating = false;

    // Funkcja sprawdzająca czy jesteśmy na urządzeniu mobilnym
    function isMobileDevice() {
        // Sprawdzamy szerokość ekranu (do 768px uznajemy za mobile)
        const isMobileWidth = window.innerWidth <= 768;
        // Sprawdzamy czy to urządzenie dotykowe
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        return isMobileWidth || isTouchDevice;
    }

    function debounce(func, wait) {
        var timeout;
        return function executedFunction() {
            var context = this;
            var args = arguments;
            var later = function () {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    function submitForm($form) {
        console.log('%c!!! URUCHAMIAM SUBMIT FORMULARZA !!! Przeładowanie strony...', 'color: red; font-weight: bold;');
        if (!$form || $form.length === 0) return;
        var $submitButton = $form.find('button[type="submit"]');
        if ($submitButton.length > 0) {
            $submitButton.prop("disabled", true).text("Filtrowanie...");
        } else {
            $form.addClass("iusac-filtering");
        }
        $form.submit();
    }

    var debouncedSubmit = debounce(function ($form) {
        submitForm($form);
    }, 600);

    function toggleAccordion($trigger) {
        var $group = $trigger.closest('.iusac-filter-group');
        // KLUCZOWE: Szukamy tylko BEZPOŚREDNIEGO dziecka .iusac-accordion-content tego grupy
        var $content = $group.children('.iusac-accordion-content');

        isAccordionAnimating = true;
        console.log('Blokada auto-submitu WŁĄCZONA dla:', $trigger.text().trim());

        $group.toggleClass('is-active');
        var isExpanded = $group.hasClass('is-active');
        $trigger.attr('aria-expanded', isExpanded);

        $content.slideToggle(300, function() {
            isAccordionAnimating = false;
            console.log('Animacja zakończona. Blokada auto-submitu WYŁĄCZONA.');
        });

        // Komunikat dla czytników ekranu
        if (isExpanded) {
            $trigger.attr('aria-label', $trigger.text().trim() + ' - rozwinięte');
        } else {
            $trigger.attr('aria-label', $trigger.text().trim() + ' - zwinięte');
            $trigger.blur();
        }
    }

    function initializeAccordion() {
        // Na starcie zamknij WSZYSTKIE akordeony (parent i nested)
        $('.iusac-filter-group').each(function() {
            var $group = $(this);
            var isActive = $group.hasClass('is-active');
            var $trigger = $group.children('.iusac-accordion-trigger');
            var $content = $group.children('.iusac-accordion-content');

            // Dla parent akordeonów - sprawdź czy są aktywne
            if ($group.hasClass('iusac-parent-accordion')) {
                if (isActive) {
                    $trigger.attr('aria-expanded', 'true');
                    $content.show();
                } else {
                    $trigger.attr('aria-expanded', 'false');
                    $content.hide();
                }
            } else if ($group.hasClass('iusac-nested-filter')) {
                // Zagnieżdżone ZAWSZE zamknięte na start
                $group.removeClass('is-active');
                $trigger.attr('aria-expanded', 'false');
                $content.hide();
            } else {
                // Zwykłe akordeony - zachowaj stan is-active
                if (isActive) {
                    $trigger.attr('aria-expanded', 'true');
                    $content.show();
                } else {
                    $trigger.attr('aria-expanded', 'false');
                    $content.hide();
                }
            }
        });

        // Obsługa kliknięcia - delegacja zdarzeń dla dynamicznej treści
        $('.iusac-filters-form').on('click', '.iusac-accordion-trigger', function(e) {
            e.preventDefault();
            e.stopPropagation(); // KLUCZOWE: Zatrzymaj propagację dla zagnieżdżonych akordeonów

            console.log('--- Accordion Trigger KLIKNIĘTY ---', $(this).text().trim());
            toggleAccordion($(this));
        });

        // Obsługa klawiatury (WCAG 2.1)
        $('.iusac-filters-form').on('keydown', '.iusac-accordion-trigger', function(e) {
            // Enter (13) lub Space (32)
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                e.stopPropagation(); // KLUCZOWE: Zatrzymuj propagację

                console.log('--- Accordion Trigger KLAWIATURA ---', $(this).text().trim());
                toggleAccordion($(this));
            }
        });

        // Inicjalizacja aria-label dla istniejących triggerów
        $('.iusac-accordion-trigger').each(function() {
            var $trigger = $(this);
            var isExpanded = $trigger.attr('aria-expanded') === 'true';
            var label = $trigger.text().trim();
            $trigger.attr('aria-label', label + (isExpanded ? ' - rozwinięte' : ' - zwinięte'));
        });
    }

    function initializeSliders() {
        $('.js-iusac-slider-container').each(function() {
            var $container = $(this);
            var $sliderElement = $container.find('.js-iusac-slider');

            if ($sliderElement.length === 0 || $sliderElement[0].noUiSlider) {
                return; // Skip if slider doesn't exist or is already initialized
            }

            var minRange = parseInt($sliderElement.data('min-range')) || 0;
            var maxRange = parseInt($sliderElement.data('max-range')) || 1000000;

            var $inputMin = $container.find('.js-iusac-slider-input-min');
            var $inputMax = $container.find('.js-iusac-slider-input-max');

            var currentMin = $inputMin.val() ? parseInt($inputMin.val()) : minRange;
            var currentMax = $inputMax.val() ? parseInt($inputMax.val()) : maxRange;

            // Initialize noUiSlider
            noUiSlider.create($sliderElement[0], {
                start: [currentMin, currentMax],
                connect: true,
                range: {
                    'min': minRange,
                    'max': maxRange
                },
                step: 1000,
                format: {
                    to: function(value) {
                        return Math.round(value);
                    },
                    from: function(value) {
                        return Number(value);
                    }
                }
            });

            // Update inputs when slider changes
            $sliderElement[0].noUiSlider.on('update', function(values, handle) {
                if (handle === 0) {
                    $inputMin.val(values[0]);
                } else {
                    $inputMax.val(values[1]);
                }
            });

            // Update slider when inputs change
            $inputMin.on('change', function() {
                var val = parseInt($(this).val()) || minRange;
                $sliderElement[0].noUiSlider.set([val, null]);
            });

            $inputMax.on('change', function() {
                var val = parseInt($(this).val()) || maxRange;
                $sliderElement[0].noUiSlider.set([null, val]);
            });

            // Submit form on slider change with debounce - WYŁĄCZONE NA MOBILKACH
            $sliderElement[0].noUiSlider.on('change', function() {
                if (!isMobileDevice()) {
                    console.log('Desktop - auto-submit dla slidera włączony');
                    var $form = $container.closest('form');
                    debouncedSubmit($form);
                } else {
                    console.log('Mobile - auto-submit dla slidera wyłączony, użyj przycisku Filtruj');
                }
            });
        });
    }

    function handleSelectRangeValidation() {
        $('.js-iusac-select-range-container').each(function() {
            var $container = $(this);
            var $minSelect = $container.find('.js-iusac-select-range-min');
            var $maxSelect = $container.find('.js-iusac-select-range-max');

            // When min changes, update max options
            $minSelect.on('change', function() {
                var minVal = parseInt($(this).val());
                if (!minVal) return;

                $maxSelect.find('option').each(function() {
                    var optVal = parseInt($(this).val());
                    if (optVal && optVal < minVal) {
                        $(this).prop('disabled', true);
                    } else {
                        $(this).prop('disabled', false);
                    }
                });
            });

            // When max changes, update min options
            $maxSelect.on('change', function() {
                var maxVal = parseInt($(this).val());
                if (!maxVal) return;

                $minSelect.find('option').each(function() {
                    var optVal = parseInt($(this).val());
                    if (optVal && optVal > maxVal) {
                        $(this).prop('disabled', true);
                    } else {
                        $(this).prop('disabled', false);
                    }
                });
            });
        });
    }

    // =========================================================
    // INICJALIZACJA PO ZAŁADOWANIU DOM
    // =========================================================
    $(document).ready(function () {
        console.log('Document ready. Inicjalizacja skryptów...');

        // Logowanie informacji o urządzeniu
        if (isMobileDevice()) {
            console.log('%c📱 WYKRYTO URZĄDZENIE MOBILNE - Auto-submit filtrów WYŁĄCZONY', 'color: blue; font-weight: bold;');
        } else {
            console.log('%c🖥️ WYKRYTO URZĄDZENIE DESKTOP - Auto-submit filtrów WŁĄCZONY', 'color: green; font-weight: bold;');
        }

        // Obsługa auto-submit dla filtrów - TYLKO NA DESKTOPIE
        $('.js-iusac-auto-submit-form').on('change', '.js-iusac-filter-trigger', function (event) {
            console.log('%c--- ZDARZENIE "CHANGE" WYKRYTE ---', 'color: orange; font-weight: bold;', event.target);

            // NOWE: Sprawdzenie czy jesteśmy na urządzeniu mobilnym
            if (isMobileDevice()) {
                console.log('%c🚫 Mobile device - auto-submit ZABLOKOWANY. Użytkownik musi kliknąć "Filtruj"', 'color: red; font-weight: bold;');
                return;
            }

            if (isAccordionAnimating) {
                console.log('%cWykryto "change", ale auto-submit jest ZABLOKOWANY, ponieważ trwa animacja.', 'color: green; font-weight: bold;');
                return;
            }

            console.log('Auto-submit NIE jest zablokowany. Sprawdzam dalej...');

            // Pomijamy inputy od suwaka - one mają własny debounce
            if ($(this).hasClass('js-iusac-slider-input-min') || $(this).hasClass('js-iusac-slider-input-max')) {
                console.log('To jest input od suwaka, on ma własny debounce. Ignoruję.');
                return;
            }

            submitForm($(this).closest('form'));
        });

        // Inicjalizacja akordeonów
        initializeAccordion();

        // Inicjalizacja suwaków
        initializeSliders();

        // Inicjalizacja walidacji select range
        handleSelectRangeValidation();

        console.log('Wszystkie listenery zdarzeń podpięte.');
    });

})(jQuery);
